import lottie from "lottie-web";

import { FunctionComponent, useEffect, useRef } from "react";

import IsLoader from "assets/lotties/loader.json";

type Props = {
  height: number;
  width: number;
};

const Loader: FunctionComponent<Props> = ({ height, width }) => {
  // 🔹 Explicitly define the ref as an HTMLDivElement or null
  const black = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (black.current) {
      lottie.loadAnimation({
        container: black.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: IsLoader,
        rendererSettings: {},
      });
    }

    // return () => {
    //   lottie.destroy();
    // };
  }, []);

  return <div ref={black} style={{ height, width }} className="mx-auto" />;
};

export default Loader;
